import { withStyles } from '@material-ui/core/styles';
import Tooltip from '@material-ui/core/Tooltip';
import Typography from '@material-ui/core/Typography';
import PropTypes from 'prop-types';
import React from 'react';
import { globalStyles } from './style/gstheme';
import SlatInnerWorkflow from './SlatInnerWorkflow';
import { isRTL } from './utils/utils';

const styles = theme => {
    return Object.assign({
        deprecated: {
            color: '#CA4F0C',
            fontSize: 10,
            display: 'block'
        },
        reverseDeprecated: {
            color: 'white',
            fontSize: 10,
            display: 'block'
        },
        custom: {
            color: '#00A9E0',
            fontSize: 10,
            display: 'block'
        },
        titleTreeBox: {
            padding: '4px 2px 2px 2px'
        },
        titleTreeText: {
            fontSize: '14px',
            opacity: 0.8,
            fontWeight: 300,
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap'
        },
        titleTreeTextLast: {
            fontWeight: 500,
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap'
        },
        childTitlesLine: {
            position: 'absolute',
            top: 26,
            bottom: 22,
            width: 1,
            left: 14,
            backgroundColor: 'white'
        },
        childTitles: {
            marginLeft: 2,
            marginTop: 6,
            fontSize: '14px'
        },
        arrow: {
            color: theme.palette.primary.light
        }
    }, globalStyles);
};


class SlatInner extends React.Component {

    render() {

        const { classes, show, title, onActivate, onDeactivate, onClick, selected, workflowStatus, hasChildren,
            titleTree, fallbackLang, notInComponent, children, deprecated, customLabel, displayLang } = this.props;
        const buttonCount = Array.isArray(this.props.children) ? this.props.children.filter(child => child).length : 1;
        const rtl = isRTL(displayLang);

        return (
            <div
                tabIndex={0}
                data-test={notInComponent ?
                    (selected ? "selected-node-inner-nic" : "node-inner-nic")
                    :
                    (selected ? "selected-node-inner" : "node-inner")}
                className={notInComponent ?
                    (selected ? classes.selectedAltSlatStyle : classes.altSlatStyle)
                    :
                    (selected ? classes.selectedSlatStyle : classes.slatStyle)}
                style={fallbackLang ?
                    { borderLeft: 'solid 3px #CA4F0C' }
                    :
                    { borderLeft: selected ? 'solid 3px #616161' : 'solid 3px #e5e5e5' }
                }
                data-fallbacklang={fallbackLang}
                onMouseEnter={onActivate}
                onMouseLeave={onDeactivate}
                onKeyDown={(ev) => {
                    if (ev.altKey && ev.key === "Enter") {
                        ev.preventDefault();
                        ev.stopPropagation();
                        onClick(ev);
                    }
                    if (ev.shiftKey && ev.key === "Enter") {
                        ev.preventDefault();
                        ev.stopPropagation();
                        onActivate(ev);
                    }
                    if (ev.ctrlKey && ev.key === "Enter") {
                        ev.preventDefault();
                        ev.stopPropagation();
                        onDeactivate(ev);
                    }
                }}
                onClick={onClick}>
                {titleTree.length > 1 ?
                    <Tooltip arrow
                        classes={{
                            arrow: classes.arrow
                        }}
                        title={
                            <div className={classes.titleTreeBox}>
                                <div data-test="title-tree-0" className={classes.titleTreeText}>{titleTree[0]}</div>
                                <div className={classes.childTitlesLine} />
                                <div className={classes.childTitles}>
                                    {titleTree.map((item, index) => index > 0 &&
                                        <div key={index} style={{ height: 24 }}>
                                            <div style={{
                                                position: 'absolute',
                                                left: 14,
                                                top: index * 24 + 14,
                                                height: 1,
                                                width: index * 12,
                                                backgroundColor: 'white'
                                            }} />
                                            <div data-test={"title-tree-" + index} className={index === titleTree.length - 1 ?
                                                classes.titleTreeTextLast
                                                :
                                                classes.titleTreeText} style={{ marginLeft: index * 12 + 12 }}>
                                                {item}
                                            </div>
                                        </div>
                                    )}
                                </div>
                            </div>
                        }>
                        <Typography
                            data-test="slat-text"
                            dir={rtl ? "rtl" : null}
                            lang={displayLang}
                            className={selected && !notInComponent ? classes.selectedSlat : classes.slat}>
                            <span data-test="slat-title">{title}</span>
                            {deprecated && <span data-test="slat-deprecated" className={selected ? classes.reverseDeprecated : classes.deprecated}>Deprecated</span>}
                            {customLabel && <span data-test="slat-custom" className={classes.custom}>{customLabel}</span>}
                        </Typography>
                    </Tooltip>
                    :
                    <Typography
                        data-test="slat-text"
                        dir={rtl ? "rtl" : null}
                        lang={displayLang}
                        className={selected && !notInComponent ? classes.selectedSlat : classes.slat}>
                        <span data-test="slat-title">{title}</span>
                        {deprecated && <span data-test="slat-deprecated" className={selected ? classes.reverseDeprecated : classes.deprecated}>Deprecated</span>}
                        {customLabel && <span data-test="slat-custom" className={classes.custom}>{customLabel}</span>}
                    </Typography>
                }
                <div style={{ float: 'right', width: 1 }}>
                    {show && hasChildren ?
                        <div className={classes.slatInner}
                            style={{ marginLeft: '-' + buttonCount * 34 + 'px', width: buttonCount * 34 + 'px' }}
                            onClick={(ev) => {
                                ev.preventDefault();
                                ev.stopPropagation();
                            }}>
                            {React.Children.map(children, child => (
                                child && <span className={classes.slatButton}>
                                    {child}
                                </span>
                            ))}
                        </div>
                        :
                        workflowStatus ?
                            <SlatInnerWorkflow workflowStatus={workflowStatus} />
                            :
                            null
                    }
                </div>
            </div>
        );
    }
}

SlatInner.defaultProps = {
    fallbackLang: false,
    notInComponent: false,
    workflowStatus: undefined,
    customLabel: undefined,
    hasChildren: false,
    deprecated: false
};

SlatInner.propTypes = {
    show: PropTypes.bool.isRequired,
    displayLang: PropTypes.string,
    deprecated: PropTypes.bool,
    hasChildren: PropTypes.bool,
    onClick: PropTypes.func.isRequired,
    customLabel: PropTypes.string,
    fallbackLang: PropTypes.bool,
    workflowStatus: PropTypes.string,
    onActivate: PropTypes.func.isRequired,
    onDeactivate: PropTypes.func.isRequired,
    titleTree: PropTypes.array,
    notInComponent: PropTypes.bool,
    title: PropTypes.any.isRequired,
    classes: PropTypes.object
};

export default withStyles(styles)(SlatInner);